module.exports = {
      id: "data-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#data",
      toString: function () {
        return this.url;
      }
    }